export default __webpack_public_path__ + "content/media/28.00fca42e.jpg";